/**
 * The app styles available, which defines how the header etc. looks like.
 */
export const Styles = {
  Cyface: 'Cyface',
  RFR: 'RFR'
}
